/* Let confirmed cart writes finish before opening the cart. No request retries. */
(() => {
  'use strict';
  const pending = new Set();
  let navigating = false;
  window.VessariqCartNavigation = {
    wait() { return Promise.all([...pending]); },
    track(request) {
      const settled = Promise.resolve(request).catch(() => {});
      pending.add(settled);
      settled.then(() => pending.delete(settled));
    }
  };
  document.addEventListener('click', async event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    const cartPath = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/') + 'cart';
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== cartPath || !pending.size) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (navigating) return;
    navigating = true;
    link.setAttribute('aria-busy', 'true');
    // Another write can begin while the first one settles; wait for that too.
    while (pending.size) await Promise.all([...pending]);
    link.removeAttribute('aria-busy');
    location.assign(url.href);
  }, true);
})();
